import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Pricing from './pages/pricing/Pricing';
import Contact from './pages/contact/Contact';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'pricing',
        element: <Pricing />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
    ],
  },
]);
